import { useDraftReturn } from "@babackapp/return-widget-components/hooks/use-draft-return";
import { useReturnableItems } from "@babackapp/return-widget-components/hooks/use-returnable-items";
import { usePublicShop } from "@babackapp/return-widget-components/queries/use-public-shop";
import { useWidgetParams } from "./use-widget-params";

export function useLineItemConfirmation() {
  const { orderId, shopSlug, shopId } = useWidgetParams();
  const draft = useDraftReturn(orderId);
  const allReturnableItems = useReturnableItems(orderId, shopSlug);
  const { data: shop } = usePublicShop(shopId);

  const singleArticleOnly = shop?.preferences?.singleArticleReturnOnly === true;
  const draftLineItemIds = new Set(draft?.lineItems.map((li) => li.lineItemId) ?? []);
  const remainingItems = singleArticleOnly
    ? []
    : allReturnableItems.filter((item) => !draftLineItemIds.has(item.line_item_id));

  return { remainingItems, orderId, shopId };
}
